module.exports = __webpack_public_path__ + "images/help/video-ical-small@2x-391497eb0b9d600904384cd993517a67.png";